import { apolloClient } from '@/setup/apollo-setup';

// Import defined GraphQL Query or Mutation
import {
  FORGOT_PASSWORD,
  REGISTER,
  RESET_PASSWORD,
  GET_CURRENT_USER,
  GET_USER_PROFILE_SHARING_URL_ONCE,
  GET_USER_PUBLIC_PROFILE,
  RESET_PASSWORD_CURRENT_USER,
} from '@/queries/modules/user';

// import axios from 'axios';
import axios from "@/setup/axios-setup";

import { setDebugStatus } from '@/utils/debugger';
import { loginEntityFromHostname } from '@/utils/login-entity';
const $debug = setDebugStatus();

import {
  error,
  // newItemSuccess,
  // updateItemSuccess,
  // deleteItemSuccess,
  serverResponseStatusSet
} from '@/utils/notification';

export default {
  selectCourseToLearn,
  login,
  forgotPassword,
  resetPassword,
  signOut,
  register,
  getCurrentUser,
  initUser,
  shareUserProfileOnce,
  getPublicProfile,
  resetPasswordCurrentUser,
}

function selectCourseToLearn(context, payload) {
  context.commit("setCourseToLearn", payload);
}

async function login({commit}, payload) {

  // console.log("Logging In", payload, "to Server:", process.env.VUE_APP_AUTH_SERVER);
  // localStorage.removeItem("token");

  commit('clearError');
  commit('setProcessing', true);
  try {
    const response = await axios({
      method: "post",
      url: process.env.VUE_APP_AUTH_SERVER + "/signin",
      data: {
        ...payload.credential,
        entity: loginEntityFromHostname(window.location.hostname),
      },
      // withCredentials: true
    });

    // console.log(response);

    if (response.status >= 200 && response.status < 400) {
      if(response.data.changePassword){
        //redirect to change password page
        payload.vm.$router.push({
          name: 'user-change-password',
          params: {
            username: payload.credential.username,
            changePasswordReason: response.data.changePasswordReason,
            oldPassword: payload.credential.password,
          }
        });
        return
      }

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('rsc', JSON.stringify(response.data.rsc));
      commit('setLoginStatus', serverResponseStatusSet("Authentication Success", response.data));
      payload.vm.$router.push("/");
    }


  } catch (e) {
    if ($debug === true) {
      // eslint-disabled no-colsole
      // console.log(e.response.status);
      // console.log(e.response.data);
    }
    if (e.response) {
      commit('setLoginStatus', serverResponseStatusSet("Authentication Error", e.response.data));
      // commit("setLoginError", e.response.data);
      // commit('setError', error(e.response.data.message));
      // notifyError(e.response.data, "Authentication Error");
    }
  }

  // apolloClient
  //   .mutate({
  //     mutation: LOGIN,
  //     variables: payload
  //   })
  //   .then(({data}) => {
  //     localStorage.setItem('user', JSON.stringify(data.signIn.user));
  //     localStorage.setItem('token', data.signIn.token);

  //     commit('setToken', data.signIn.token);
  //     commit('setCurrentUser', data.signIn.user);
  //   })
  //   .catch((err) => {
  //     localStorage.removeItem('user');
  //     localStorage.removeItem('token');

  //     commit('setLoginError', error(err.message, 'notification.login-error-title'));

  //     setTimeout(() => {
  //       commit('clearError');
  //     }, 3000);
  //   });
}

function forgotPassword({commit}, payload) {
  commit('clearError');
  commit('setProcessing', true);

  apolloClient
    .mutate({
      mutation: FORGOT_PASSWORD,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    .then(() => {
      commit('clearError');
      commit('setForgotMailSuccess');
    })
    .catch((err) => {
      commit('setError', error(err.message));

      setTimeout(() => {
        commit('clearError');
      }, 3000);
    });
}

function resetPassword({commit}, payload) {
  commit('clearError');
  commit('setProcessing', true);

  apolloClient
    .mutate({
      mutation: RESET_PASSWORD,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    .then(() => {
      commit('clearError');
      commit('setResetPasswordSuccess');
    })
    .catch((err) => {
      commit('setError', error(err.message));

      setTimeout(() => {
        commit('clearError');
      }, 3000);
    });
}

function signOut({ commit }, vm) { // eslint-disable-line no-unused-vars
  // Unsubscribe user session on back-end.

  axios({
    url: process.env.VUE_APP_AUTH_SERVER + "/signout",
    data: {
      token: localStorage.getItem("token")
    }
  // }).then(r => {

  //   // TODO: Commit successfully signout result to inform user.


  // }).catch(e => {

  //   // TODO: Send error log for stats


  }).finally(() => {
    // Removed token
    localStorage.removeItem('token');

    if (vm) {
      if (vm.$router && vm.$route.fullPath !== "/user/login") {
        vm.$router.push("/user/login");
      }
    } else if (window.location.pathname !== process.env.BASE_URL + 'user/login') {
      window.location = process.env.BASE_URL + 'user/login';
    }
  })

}

function register({commit}, payload) {
  commit('clearError');
  commit('setProcessing', true);

  apolloClient
    .mutate({
      mutation: REGISTER,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    .then(({data}) => {
      localStorage.setItem('user', JSON.stringify(data.register.user));
      localStorage.setItem('token', data.register.token);

      commit('setToken', data.register.token);
      commit('setCurrentUser', data.register.user);
    })
    .catch((err) => {
      localStorage.removeItem('user');
      localStorage.removeItem('token');

      commit('setError', error(err.message));

      setTimeout(() => {
        commit('clearError');
      }, 3000);
    });
}

async function getCurrentUser(context) {
  // console.log("Store: getCurrentUser action");
  // context.commit('setProcessing', true);
  try {

    // console.log("try to query GET_CURRENT_USER")
    const result = await apolloClient
      .query({
        query: GET_CURRENT_USER,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })

    const { data } = result;

    context.commit('setCurrentUser', data.getCurrentUser);

    this._vm.$context.$currentUser = Object.assign(this._vm.$currentUser, this.state.User.currentUser);
    this._vm.$currentUser = this._vm.$context.$currentUser;
    this._vm.$context.$currentUser.active = true;

    // Interaction on Subscription succeeded.
    // this._vm.$context.subscription.subscriber("user", this._vm.$currentUser);

    return data.getCurrentUser

  } catch (e) {
    // console.log("getCurrentUser Error", e);
    context.commit('setError', error(e));
    return null;
  }
}

/*
  Initialize User State
*/
async function initUser (context,/*  payload */) {

  const token = localStorage.getItem("token");
  const { User } = context.rootState;
  const { currentUser, profile } = User;

  if (token
    && (!currentUser || !profile)
  ) {
    // console.log("User data is initializing");
    // console.log("Initializing User");
    context.commit('setProcessing', true);
    try {

      const currentUser = await context.dispatch("getCurrentUser");

      const data = currentUser;

      if (data) {
        if (data.getCurrentUser) {
          if (typeof data.getCurrentUser.profile === "string") {
            data.getCurrentUser.profile = JSON.parse(data.getCurrentUser.profile);
          }
          if (typeof data.getCurrentUser.meta === "string") {
            data.getCurrentUser.meta = JSON.parse(data.getCurrentUser.meta);
          }
          context.commit("setUser", data.getCurrentUser);
          context.commit("setProfile", data.getCurrentUser.profile);

          return { status: { success: true, error: false, message: "" }}
        }
      }
    } catch (e) {
      // console.log(e);
      context.commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  }
}

async function shareUserProfileOnce(context, payload) { // eslint-disable-line no-unused-vars
  const { commit } = context;
  commit('setProcessing', true);

  try {
    const result = await apolloClient
      .query({
        query: GET_USER_PROFILE_SHARING_URL_ONCE,
        variables: {
          "mode": "teacher"
        },
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const { data  } = await result;
    return data.getUserProfileSharingUrlOnce;

  } catch (e) {
    // console.log(e);

    commit('setError', error(e));
    return null;

  }
}

async function getPublicProfile(context, payload) {
  // const $location = "VuexStore/UserModule/Actions/getPublicProfile()";

  context.commit('setProcessing', true);
  try {
    const variables = payload;

    const response = await apolloClient
      .query({
        query: GET_USER_PUBLIC_PROFILE,
        variables,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    // console.log($location, response);

    const { data } = await response;
    return data.getUserPublicProfile;

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

async function resetPasswordCurrentUser(context, payload) {
  context.commit('clearError');
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: RESET_PASSWORD_CURRENT_USER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setProcessing', false);

      return data.resetPasswordCurrentUser
    }
  }catch (e){
    context.commit('setError', error(e));
    return {error: true, message: e.message};
  }

}
